function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0-wp{fill:none;stroke:currentColor;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "st0-wp",
  d: "M21,11.5c0,1.3-0.3,2.6-0.9,3.8c-1.4,2.9-4.4,4.7-7.6,4.7c-1.3,0-2.6-0.3-3.8-0.9L3,21l1.9-5.7 C4.3,14.1,4,12.8,4,11.5c0-3.2,1.8-6.2,4.7-7.6C9.9,3.3,11.2,3,12.5,3H13c4.3,0.2,7.8,3.7,8,8V11.5z"
});

var _ref4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M16.7,13.6V15c0,0.5-0.4,0.9-0.9,0.9c0,0-0.1,0-0.1,0c-1.3-0.1-2.6-0.6-3.8-1.3c-1.1-0.7-2-1.6-2.6-2.6 C8.6,10.7,8.2,9.4,8,8.1c0-0.5,0.3-0.9,0.8-1c0,0,0.1,0,0.1,0h1.3c0.4,0,0.8,0.3,0.9,0.8c0.1,0.4,0.2,0.8,0.3,1.2 c0.1,0.3,0,0.7-0.2,0.9l-0.6,0.6c0.6,1.1,1.5,2,2.6,2.6l0.6-0.6c0.2-0.2,0.6-0.3,0.9-0.2c0.4,0.1,0.8,0.3,1.2,0.3 C16.4,12.8,16.7,13.2,16.7,13.6z"
}));

var SvgWhatsapp01 = function SvgWhatsapp01(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWhatsapp01, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/whatsapp-01.252b92a2.svg";
export { ForwardRef as ReactComponent };